import { useProductSelector } from "$store/sdk/useProductSelector.tsx";
import Icon from "$store/components/ui/Icon.tsx";
import { computed } from "@preact/signals";

interface Props {
  skus: string[];
  seller?: string;
}

export default function ToggleAll({ skus, seller = "1" }: Props) {
  const { selectedProducts, handleSelect } = useProductSelector();

  const isAllSelected = computed(() => {
    const allSkusAreIncluded = selectedProducts.value.length === skus.length;
    const allSkusAreSelected = selectedProducts.value.every((p) =>
      p.isSelected
    );
    return allSkusAreIncluded && allSkusAreSelected;
  });

  const toggleAll = () => {
    if (!isAllSelected.value) {
      skus.forEach((sku) => handleSelect(sku, true, seller));
    } else {
      skus.forEach((sku) => handleSelect(sku, false, seller));
    }
  };

  return (
    <div class="flex justify-center items-center gap-3">
      <div class="relative leading-[0]">
        <input
          id={`media-shelf-select-all`}
          class="w-6 h-6 border border-tw-secondary-200 rounded appearance-none cursor-pointer checked:bg-tw-secondary-200"
          type="checkbox"
          checked={isAllSelected.value}
          onChange={toggleAll}
        />

        <Icon
          id="Check"
          class="text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
          size={11}
        />
      </div>

      <label
        class={`text-sm leading-5 font-bold cursor-pointer ${
          isAllSelected.value ? "text-tw-secondary-200" : "text-tw-neutral-500"
        }`}
        htmlFor={`media-shelf-select-all`}
      >
        Selecionar todos os produtos
      </label>
    </div>
  );
}
